module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evolution-report"
  }, [(_vm.title) ? _c('h4', {
    staticClass: "report-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('ReportFilterBadge', {
    attrs: {
      "metadata": _vm.metadata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "years-grid",
    style: (_vm.gridStyle)
  }, _vm._l((_vm.entries), function(entry) {
    return _c('div', {
      key: entry.year,
      staticClass: "year-block"
    }, [_c('h5', {
      staticClass: "year-title"
    }, [_vm._v(_vm._s(entry.year))]), _vm._v(" "), _c('div', {
      staticClass: "year-body"
    }, [_c(_vm.reportComponent, {
      tag: "component",
      attrs: {
        "data": _vm.entryData(entry)
      }
    })], 1)])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee216bdc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/EvolutionTextualReport.vue
// module id = 774
// module chunks = 1